import type { ClientPostsViewEvent } from '@DigitaleDoerfer/digitale-doerfer-api';

import { useGrapevinePostEventsApi } from '@/features/api/hooks/grapevine-post-events/useGrapevinePostEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useSendPostView = () => {
  const api = useGrapevinePostEventsApi();

  return useApiMutation({
    mutationFn: (clientPostsViewEvent: ClientPostsViewEvent) =>
      api.onPostsViewEvent({ clientPostsViewEvent })
  });
};
